import React from 'react';
import classnames from 'classnames';
import s from './BlurredBackground.scss';
export const BlurredBackground = ({ imageUrl, clientSideBlur = false })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['image'], clientSideBlur && s['image-blurred']),
        style: {
            backgroundImage: `url('${imageUrl}')`
        }
    }));
};
BlurredBackground.displayName = 'BlurredBackground';
export default BlurredBackground;
